import { useMemo, useSyncExternalStore } from 'react';

import DOMPurify from 'dompurify';

const subscribeToNothing = () => () => {};
const hasDom = () => true;
const hasNoDom = () => false;

export const useSanitizedHtml = (html: string | Node) => {
  const canSanitize = useSyncExternalStore(
    subscribeToNothing,
    hasDom,
    hasNoDom,
  );

  return useMemo(
    () => ({ __html: canSanitize ? DOMPurify.sanitize(html) : '' }),
    [canSanitize, html],
  );
};
